export default "__VITE_ASSET__DAOqYjrN__"